import womensHealthHeroGradients from '@/app/[locale]/womens-health/_data/womensHealthHeroGradients';
import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';

const WomensHealthHero = () => {
  return (
    <LandingPageHero
      backgroundProps={{
        color: 'sandstone-400',
        gradients: womensHealthHeroGradients,
      }}
      copy="womens_health_hero_copy"
      data-cy="womens-health-hero"
      eyebrow="womens_health"
      images={[
        {
          localizedAlt: 'michelle_l_image_alt',
          src: 'womens-health/womens_health_hero_michelle_or4',
          quote: 'michelle_l_quote',
          name: 'Michelle L.',
        },
        {
          localizedAlt: 'les_a_image_alt',
          src: 'womens-health/womens_health_hero_les_or4',
          quote: 'les_a_quote',
          name: 'Les A.',
        },
      ]}
      textColor="text-olive-800"
      title="womens_health_hero_title"
    />
  );
};
export default WomensHealthHero;
